import { createTheme } from '@mui/material/styles'
import { red } from '@mui/material/colors'

// A custom theme for this app
const theme = createTheme({
    direction: 'rtl',
    palette: {
        mode: 'dark',
        primary: {
            main: '#006DC3',
            dark: '#10228f',
            light: '#569aff',
        },
        secondary: {
            main: '#607D8B',
        },
        error: {
            main: red.A400,
        },
        background: {
            paper: '#283340',
            default: '#151820',
        },
        warning: {
            main: '#FFCC00',
        },
    },
    shape: {
        borderRadius: 15,
    },
    typography: {
        fontFamily: 'YekanBakh',
    },
    components: {
        MuiButton: {
            styleOverrides: {
                contained: {
                    boxShadow: 'none',
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    boxShadow: 'none',
                },
            },
        },
        MuiAutocomplete: {
            styleOverrides: {
                listbox: {
                    borderRadius: 'none',
                },
            },
        },
    },
})

export default theme
